import InstantLuckyDrawListPanel from './instantLuckyDrawListPanel.container';

export default InstantLuckyDrawListPanel;